class MFRProductGrid {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            option: "[data-frequency]",
            item: ".product-grid__item",
            fixedBar: ".product-grid__subscription-sticky",
            subscription: ".product-grid__subscription"
        }

        this.init();
    }

    init() {
        this.$option = this.$element.find( this.selectors.option );
        this.$item = this.$element.find( this.selectors.item );
        this.$subscription = this.$element.find( this.selectors.subscription );

        if( this.$option.length ) this.updateFrequencies( this.$element.find( `${this.selectors.option}.is-active` ).data( "frequency" ) );
        
        this.initFixedBar();

        this.$option.on( "click", this.__handleButtonClick.bind( this ) );
    }

    __handleButtonClick(e) {
        const freq = $( e.currentTarget ).data( "frequency" );
        const fixedBar = $( `${ this.selectors.fixedBar }[data-for="${ this.$subscription.attr( "id" ) }"]` );
        this.$option.removeClass( "is-active" );
        $( e.currentTarget ).addClass( "is-active" );

        
        fixedBar.find( this.selectors.option ).removeClass( "is-active" );
        fixedBar.find( `${ this.selectors.option }[data-frequency="${ freq }"]` ).addClass( "is-active" );

        this.updateFrequencies(freq);
    }

    updateFrequencies(freq) {
        if( !freq ) return;
        this.$item.each( ( i, e ) => {
            const form = $( e ).find( "form" );
            const frequency = $( e ).data( `freq-${ freq }` );
            const price = $( e ).data( `price-${ freq }` ); // BB

            $( e ).find('.product-card__button > .price').text(`$${price}`); // BB

            if( !form.find( "input[name='selling_plan']").length )
                form.append( `<input type="hidden" name="selling_plan" value="${ frequency }">` );
            else
                form.find( "input[name='selling_plan']" ).val( frequency );
        } );
    }

    initFixedBar() {
        if( $( ".smooth-wrapper" ).find( `${ this.selectors.fixedBar }[data-for="${ this.$subscription.attr( "id" ) }"]` ).length ) return;
        
        this.$fixedBar = $( `
            <div 
                class="${ this.selectors.fixedBar.replace( ".", "" ) }"
                data-for="${ this.$subscription.attr( "id" ) }"></div>
        ` );
        $( ".smooth-wrapper" ).append( this.$fixedBar );
        this.$fixedBar.append( this.$subscription.clone().addClass( "sticky-bar" ) );
        gsap.set( this.$fixedBar, {
            y: `-${ this.$fixedBar.height() }`
        } );

        this.initFixedBarGSAPEvents();
        this.initFixedBarEvents();
    }

    initFixedBarGSAPEvents() {
        const headerHeight = $( "header.header" ).height();
        const enterAnim = () => {
            gsap.set( this.$fixedBar, {
                top: $( "header.header" ).height(),
                y: `-${ headerHeight  + this.$fixedBar.height() }`
            } );
            gsap.to( this.$fixedBar, {
                y: 0,
                ease: "back",
                duration: 0.4
            } );
        }
        const exitAnim = () => {
            gsap.to( this.$fixedBar, {
                y: `-${ headerHeight + this.$fixedBar.height() }`,
                ease: "back",
                duration: 0.4
            } );
        }

        const scrollTrigger = ScrollTrigger.create( {
            trigger: this.$subscription,
            start: "bottom top",
            endTrigger: this.$element,
            end: "bottom top",
            onEnter: enterAnim,
            onLeaveBack: exitAnim,
            onLeave: exitAnim,
            onEnterBack: enterAnim
        } );
    }

    initFixedBarEvents() {
        this.$fixedBar.find( this.selectors.option ).on( "click", ( e ) => {
            const freq = $( e.currentTarget ).data( "frequency" );

            this.$element.find( `${ this.selectors.option }[data-frequency="${ freq }"]` ).click();
        } );
    }
}